import { ActivatedRoute, Router } from '@angular/router';
import { Component, EventEmitter, Output, Input } from '@angular/core';
import { Filters } from '../sidenav/search-sidenav.component';

@Component({
  selector: 'applied-filters',
  templateUrl: './applied-filters.component.html',
  styleUrls: ['./applied-filters.component.scss']
})
export class AppliedFiltersComponent {

  @Input() filters: Filters;
  @Output() onFilterRemoved: EventEmitter<'category'> = new EventEmitter();

  constructor(private router: Router,
              activatedRoute: ActivatedRoute) {
    
  }
  
  removeFilter(filterName: 'category') {
    this.onFilterRemoved.emit(filterName);
  }
  
  get category(): string | undefined {
    if (!this.filters.category) {
      return undefined;
    }
    
    return this.extractMostSpecificCategory(this.filters.category.name);
  }
  
  private extractMostSpecificCategory(category: string) {
    const parts = category.split(">");
    return parts[parts.length - 1].trim();
  }
}
